import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyC4hgI1PtFQkMZIOEQdT5kgg8UnXba3U3k",
    authDomain: "slack-clone-9331a.firebaseapp.com",
    projectId: "slack-clone-9331a",
    storageBucket: "slack-clone-9331a.appspot.com",
    messagingSenderId: "576950410025",
    appId: "1:576950410025:web:436a4903ff9c12510b7538"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  
  export { auth, provider }
  export default db;

  